import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerSpinAccelerationListItem = ({ acceleration, updateVisualizerSettings }) => {
    const onAccelerationChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({
            spinSettings: { acceleration: value }
        });
    };

    return (  
        <SliderListItem
            title='Acceleration'
            toolTip={`Control how spin reacts to loud bass. At 0 acceleration there is no reactivity. Positive acceleration increases clockwise spin speed during loud bass. Negative acceleration increases count-clockwise spin speed during loud bass.`}
            value={acceleration}
            displayMultiplier={1}
            min={-100}
            max={100}
            step={1}
            onValueChange={onAccelerationChange}
        /> 
    );
};

const mapStateToProps = (state) => {
    const { acceleration } = state.createPreview.present.videoSettings.visualizer.spinSettings;
    return { acceleration };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerSpinAccelerationListItem);